import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductModal.css';

const ProductModal = ({ product, isOpen, onClose }) => {
  const navigate = useNavigate();
  const [currentIdx, setCurrentIdx] = React.useState(0);

  // Reset to the first image whenever the modal opens or a new product is selected
  React.useEffect(() => {
    if (isOpen) setCurrentIdx(0);
  }, [isOpen, product]);

  if (!isOpen) return null;

  const handleInquiry = () => {
    onClose();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  const images = Array.isArray(product?.image) ? product.image : [product?.image];
  const isMultiple = images.length > 1;
  const currentImage = images[currentIdx];

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIdx((prevIdx) => (prevIdx + 1) % images.length);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentIdx((prevIdx) => (prevIdx - 1 + images.length) % images.length);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>&times;</button>
        <div className="modal-body">
          <div className="modal-image-section">
            <img src={currentImage} alt={product.name} className="modal-main-image" />
            {isMultiple && (
              <>
                <button className="modal-arrow modal-prev" onClick={handlePrev}>&#10094;</button>
                <button className="modal-arrow modal-next" onClick={handleNext}>&#10095;</button>
              </>
            )}
          </div>
          <div className="modal-info-section">
            <span className="modal-category">{product.category}</span>
            <h2 className="modal-title">{product.name}</h2>
            <div className="modal-divider"></div>
            <p className="modal-description">
              {product.description || "Handcrafted with the finest quality leather, this piece showcases our 50 years of artisanal expertise. Each stitch is meticulously placed to ensure durability and a timeless aesthetic."}
            </p>
            <ul className="modal-specs">
              <li><strong>Material:</strong> Premium Full-Grain Leather</li>
              <li><strong>Stitching:</strong> Hand-finished Artisanal Thread</li>
              <li><strong>Origin:</strong> Handcrafted in Kolkata, India</li>
              <li><strong>Standards:</strong> Export Quality International Standard</li>
            </ul>
            <div className="modal-cta">
              <button className="modal-inquiry-btn" onClick={handleInquiry}>INQUIRE ABOUT THIS PRODUCT</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;
